<script>
import VDataTableUsers from "@/components/VDataTable/VDataTableUsers.vue";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import UsersModal from "@/components/Users/UsersModal.vue";
import ComponentsKeys from "@/mixins/ComponentsKeys";
import VDialogConfirm from "@/components/commonComponents/VDialogConfirm.vue";


export default {
    name: "Users",
    components: {
        VDialogConfirm,
        UsersModal,
        AjaxLoad,
        VDataTableUsers,
    },
    mixins: [
        ComponentsKeys,
    ],
    data() {
        return {
            title: 'Пользователи',
            componentsKeys: {
                usersModal: this.getRandomKey('usersModal'),
            },
            notifyOptions: {
                title: 'Пользователи',
            },
        };
    },
    methods: {
        doShowModal(id) {
            this.$refs.usersModal.show(id)
                .then(result => {
                    if (result !== false) {
                        this.$refs.ajax.load();
                    }
                })
                .finally(() => {
                    this.updateComponentKey('usersModal');
                });
        },
        onDblClickRow(e, {item}) {
            this.doShowModal(item.id);
        },
        onClickAdd() {
            this.doShowModal(0);
        },
        onClickDelete(item) {
            this.$refs.confirmDelete.show(item)
                .then(response => {
                    if (response !== false) {
                        this.$refs.ajax.load();
                    }
                })
                .catch(this.notifyError);
        },
        onConfirmDelete(item) {
            return this.$api.delete(this.$apiUrl.getUserUrl({id_users: item.id}));
        },
    },
}
</script>

<template>
    <v-container fluid class="down-top-padding">
        <v-row :no-gutters="false">
            <v-col>
                <v-card>
                    <ajax-load
                        ref="ajax"
                        :url="$apiUrl.getUsersUrl()"
                        :transform="response => response.data.data"
                        v-slot="{data, resolved}"
                    >
                        <v-data-table-users
                            :heading="title"
                            :items="data"
                            :loading="!resolved"
                            filter
                            search=""
                            with-toolbar
                            @dblclick:row="onDblClickRow"
                            @click:add="onClickAdd"
                            @click:delete="onClickDelete"
                            @click:reload="() => $refs.ajax.load()"
                        ></v-data-table-users>
                    </ajax-load>
                </v-card>
            </v-col>
        </v-row>

        <users-modal
            ref="usersModal"
            :key="componentsKeys.usersModal"
        ></users-modal>

        <v-dialog-confirm
            ref="confirmDelete"
            type="delete"
            @confirm="onConfirmDelete"
            v-slot="{data}"
        >
            Удалить пользователя {{ data.email }}?
        </v-dialog-confirm>

    </v-container>
</template>

<style scoped lang="scss">

</style>
